<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div>
        <card class="no-border-card mt-1" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template v-slot:header>
            <div class="row align-items-center py-4">
              <div class="col-lg-6 col-8">
                <h3 class="mb-0">Admin Control Panel</h3>
              </div>
            </div>
          </template>
          <div class=" container-fluid">
            <div class="row ">
              <div class="mx-auto ">
                <div class="mt-2 row">
                  <div class="col-lg-4 ">
                    <div class="card h-100 ">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0  font-weight-bold">Place an order </p>
                          <p class="card-text text-sm ">Execute buy or sell trade </p>
                        </div>
                        <div class="pt-1">
                          <base-button type="primary" class="w-100" @click="() => {
                            this.modals.classic = true; this.placeOrder.modalPlaceOrder = true;
                          }">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end"><span
                                  class="text-white"><i class="fas fa-chart-line"></i></span></div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start"> <span
                                  class="ml-1 text-white">PlaceOrder</span></div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" col-lg-4 mt-md-0">
                    <div class="card h-100 ">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0 font-weight-bold">Close open positions</p>
                          <p class="card-text text-sm">close all open positions for the selected individuals</p>
                        </div>
                        <div class="pt-1">
                          <base-button type="warning" class="w-100" @click="() => {
                            modals.classic = true;
                            this.exitAll.modalExitAll = true;
                          }">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end"> <span
                                  class="text-white"><i class="fas fa-times"></i></span></div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start"> <span
                                  class="ml-1 text-white ">Square Off</span></div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-md-0">
                    <div class="card h-100 ">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0 font-weight-bold">Close all open positions</p>
                          <p class="card-text text-sm">close all open orders for all customers</p>
                        </div>
                        <div class="pt-1">
                          <base-button type="default" class="w-100" @click="() => {
                            modals.classic = true;
                            this.exitAllOrder.modalExitAllOrder = true;
                          }">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end">
                                <span class="text-white"><i class="fas fa-sign-out-alt"></i></span>
                              </div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start">
                                <span class="ml-1 text-white">Exit All Orders</span>
                              </div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-lg-5  row">
                  <div class="col-lg-4 mb-lg-4 mt-md-0">
                    <div class="card h-100">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0 font-weight-bold">Play </p>
                          <p class="card-text text-sm">Start or resume trade entries</p>
                        </div>
                        <div class=" pt-1 ">
                          <base-button type="success" class="w-100" @click="() => {
                            modals.classic = true;
                            this.play.modalPlay = true;
                          }">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end">
                                <span class=" text-white ">
                                  <i class="fas fa-play"></i>
                                </span>
                              </div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start">
                                <span class="ml-1 text-white pl-0">Play</span>
                              </div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-lg-4 mt-md-0">
                    <div class="card h-100">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0 font-weight-bold">Pause</p>
                          <p class="card-text text-sm">Temporarily stop trade entries</p>
                        </div>
                        <div class=" pt-1 ">
                          <base-button @click="() => {
                            modals.classic = true;
                            this.pause.modalPause = true;
                          }" type="secondary" class="w-100">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end">
                                <span class=" text-white ">
                                  <i class="fas fa-pause"></i>
                                </span>
                              </div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start">
                                <span class="ml-1 text-white pl-0">Pause</span>
                              </div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" mb-4 col-lg-4 mt-md-0">
                    <div class="card h-100 ">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0 font-weight-bold">Turn off</p>
                          <p class="card-text text-sm">Stop production completely</p>
                        </div>
                        <div class="pt-1">
                          <base-button icon type="danger" class=" w-100" @click="() => {
                            this.modals.classic = true;
                            this.turnOff.modalTurnOff = true;
                          }">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end">
                                <span class="text-white"><i class="fas fa-power-off"></i></span>
                              </div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start">
                                <span class="ml-1 text-white">Turn Off</span>
                              </div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-lg-5 row mb-4">
                  <div class="col-lg-4 ">
                    <div class="card h-100 ">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0  font-weight-bold">Place Custom Order </p>
                          <p class="card-text text-sm ">To execute a trade with desired quantity </p>
                        </div>
                        <div class="pt-1">
                          <base-button type="instagram" class="w-100" @click="() => {
                            this.modals.classic = true; this.CustomPlaceOrder.modalCustomPlaceOrder = true;
                          }">
                            <div class="row">
                              <div class="col-3 d-flex justify-content-end pr-0 align-items-end"><span
                                  class="text-white"><i class="fas fa-chart-line"></i></span></div>
                              <div class="col-9 d-flex justify-content-start pl-0 align-items-start"> <span
                                  class="ml-1 text-white">Custom PlaceOrder</span></div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 mt-md-0">
                    <div class="card h-100 ">
                      <div class="text-center card-body">
                        <div class="h-50">
                          <p class="card-text mb-0 font-weight-bold">User Login</p>
                          <p class="card-text text-sm">Login the selected user manually.</p>
                        </div>
                        <div class="pt-1">
                          <base-button type="vimeo" class="w-100" @click="() => {
                            modals.classic = true;
                            this.userLogin.modalUserLogin = true;
                          }">
                            <div class="row">
                              <div class="col-5 d-flex justify-content-end pr-0 align-items-end">
                                <span class="text-white"><i class="fas fa-sign-in-alt"></i></span>
                              </div>
                              <div class="col-7 d-flex justify-content-start pl-0 align-items-start">
                                <span class="ml-1 text-white">Login</span>
                              </div>
                            </div>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
  <ExitAllModal :showModal="modals.classic" :modalExitAll="exitAll.modalExitAll" :currentUser="currentUser"
    @updateParameters=handleExitAllParameters>
  </ExitAllModal>

  <ExitAllOrderModal :showModal="modals.classic" :modalExitAllOrder="exitAllOrder.modalExitAllOrder"
    @updateParameters=handleExitAllOrderParameters>
  </ExitAllOrderModal>

  <PowerOffModal :showModal="modals.classic" :modalTurnOff="turnOff.modalTurnOff" :currentUser="currentUser"
    @updateParameters=handleTurnOffParameters>
  </PowerOffModal>

  <PlaceOrderModal :showModal="modals.classic" :modalPlaceOrder="placeOrder.modalPlaceOrder" :currentUser="currentUser"
    @updateParameters=handlePlaceOrderParameters>
  </PlaceOrderModal>

  <PlayModal :showModal="modals.classic" :modalPlay="play.modalPlay" @updateParameters=handlePlayParameters>
  </PlayModal>

  <PauseModal :showModal="modals.classic" :modalPause="pause.modalPause" @updateParameters=handlePauseParameters>
  </PauseModal>

  <CustomPlaceOrderModal :showModal="modals.classic" :CustomPlaceOrder="CustomPlaceOrder.modalCustomPlaceOrder"
    @updateParameters=handleCustomPlaceOrderParameters>
  </CustomPlaceOrderModal>

  <UserLoginModal :showModal="modals.classic" :modalUserLogin="userLogin.modalUserLogin"
    @updateParameters=handleUserLoginParameters>
  </UserLoginModal>

</template>
<script>
import ExitAllModal from "./Components/ExitAllModal.vue";
import ExitAllOrderModal from "./Components/ExitAllOrderModal.vue";
import PowerOffModal from "./Components/PowerOffModal.vue";
import PlaceOrderModal from "./Components/PlaceOrderModal.vue";
import PlayModal from "./Components/PlayModal.vue";
import PauseModal from "./Components/PauseModal.vue";
import CustomPlaceOrderModal from "./Components/CustomPlaceOrderModal.vue";
import UserLoginModal from "./Components/UserLoginModal.vue";
export default {
  components: {
    ExitAllModal,
    ExitAllOrderModal,
    PowerOffModal,
    PlaceOrderModal,
    PlayModal,
    PauseModal,
    CustomPlaceOrderModal,
    UserLoginModal,
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      isPlaying: false,
      users: [],
      currentUser: {},
      brokers: [],
      otp: "",
      placeOrder: {
        modalPlaceOrder: false,
      },
      pause: {
        modalPause: false,
      },
      play: {
        modalPlay: false,
      },
      exitAll: {
        modalExitAll: false,
      },
      exitAllOrder: {
        modalExitAllOrder: false,
      },
      turnOff: {
        modalTurnOff: false,
      },
      CustomPlaceOrder: {
        CustomPlaceOrder: false,
      },
      userLogin: {
        modalUserLogin: false,
      },
    }
  },
  methods: {
    handleExitAllParameters(showModal, modalExitAll) {
      this.modals.classic = showModal;
      this.exitAll.modalExitAll = modalExitAll;
    },
    handlePlayParameters(showModal, modalPlay) {
      this.modals.classic = showModal;
      this.play.modalPlay = modalPlay;
    },
    handlePauseParameters(showModal, modalPause) {
      this.modals.classic = showModal;
      this.pause.modalPause = modalPause;
    },
    handleExitAllOrderParameters(showModal, modalExitAllOrder) {
      this.modals.classic = showModal;
      this.exitAllOrder.modalExitAllOrder = modalExitAllOrder;
    },
    handleTurnOffParameters(showModal, modalTurnOff) {
      this.modals.classic = showModal;
      this.turnOff.modalTurnOff = modalTurnOff;
    },
    handlePlaceOrderParameters(showModal, modalPlaceOrder) {
      this.modals.classic = showModal;
      this.placeOrder.modalPlaceOrder = modalPlaceOrder;
    },
    handleCustomPlaceOrderParameters(showModal, modalCustomPlaceOrder) {
      this.modals.classic = showModal;
      this.CustomPlaceOrder.modalCustomPlaceOrder = modalCustomPlaceOrder;
    },
    handleUserLoginParameters(showModal, modalUserLogin) {
      this.modals.classic = showModal;
      this.userLogin.modalUserLogin = modalUserLogin;
    },
  },
};
</script>
